import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal, useModals } from "@/modals"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./SettingsModal.module.scss"
import { LanguageSwitcher, MusicVolume } from "./ui"

const modalType = "settings"

export const SettingsModal: FC = () => {
  const { modal, getModalParams } = useModal(modalType)
  const { openModal } = useModals()
  const { t } = useTranslation()

  const params = getModalParams(modalType)

  const handleBack = () => {
    params?.onBack?.()
    modal.close()
  }

  const handleClose = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.SettingsModal)}
      body={{ className: styles.SettingsModal_body }}
    >
      <Modal.StoneFlexContainer
        className={styles.SettingsModal_container}
        content={{ className: styles.SettingsModal_content }}
        outside={
          <>
            <div className={clsx(styles.SettingsModal_footerButtons)}>
              {params?.onBack ? (
                <Button
                  className={clsx(styles.SettingsModal_footerButtons_item)}
                  styles="green"
                  onClick={handleBack}
                >
                  {t("button.back")}
                </Button>
              ) : (
                <Button
                  className={clsx(styles.SettingsModal_footerButtons_item)}
                  styles="green"
                  onClick={handleClose}
                >
                  {t("button.close")}
                </Button>
              )}
            </div>
          </>
        }
      >
        <OutlinedText className={clsx(styles.SettingsModal_title)}>
          {t("options")}
        </OutlinedText>
        <MusicVolume className={clsx(styles.SettingsModal_musicVolume)} />
        <LanguageSwitcher
          className={clsx(styles.SettingsModal_languageSwitcher)}
        />
        <div className={styles.SettingsModal_legalRow}>
          <button
            type="button"
            className={styles.SettingsModal_legalRow_link}
            onClick={() => openModal("termsOfUse")}
          >
            {t("legal.terms")}
          </button>
          <button
            type="button"
            className={styles.SettingsModal_legalRow_link}
            onClick={() => openModal("privacyPolicy")}
          >
            {t("legal.privacy")}
          </button>
        </div>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
